import React from 'react';

interface CharacterPlayCardProps {
  characterId: string;
  playCount: number;
  percentage: number;
  isMostPlayed?: boolean;
}

const CharacterPlayCard: React.FC<CharacterPlayCardProps> = ({
  characterId,
  playCount,
  percentage,
  isMostPlayed = false,
}) => {
  return (
    <div className={`p-4 rounded-lg border ${
      isMostPlayed 
        ? 'border-yellow-300 bg-yellow-50' 
        : 'border-gray-200 bg-white'
    } transition-all duration-200 hover:shadow-sm`}>
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <div className="flex items-center">
            <h4 className="text-lg font-medium text-gray-900">
              {characterId}
            </h4>
            {isMostPlayed && (
              <span className="ml-2 px-2 py-1 text-xs font-medium bg-yellow-200 text-yellow-800 rounded-full">
                Most Played
              </span>
            )}
          </div>
          <div className="mt-1 flex items-center space-x-4">
            <span className="text-sm text-gray-600">
              {playCount} {playCount === 1 ? 'game' : 'games'}
            </span>
            <span className="text-sm text-gray-500">
              {percentage.toFixed(1)}%
            </span>
          </div>
        </div>
        <div className="ml-4">
          <div className="w-16 bg-gray-200 rounded-full h-2">
            <div
              className={`h-2 rounded-full ${
                isMostPlayed ? 'bg-yellow-500' : 'bg-blue-500'
              }`}
              style={{ width: `${Math.min(percentage, 100)}%` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CharacterPlayCard;